module.exports = __webpack_public_path__ + "img/icon-audio-back.2d561882.png";